<template>
  <v-container>
    <v-layout row>
      <v-layout column class="grey">
        <span>"Hello1"</span>
      </v-layout>
      <v-layout column>
        <span>"Hello"</span>
      </v-layout>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import { clean } from '../utilities/clean'
export default {
  created () {
    axios
      .get(process.env.VUE_APP_BACKEND + 'workorders/218256')
      .then(response => {
        var desc = response.data.data.otherDesc.slice(0, 280)
        console.log(desc)
        console.log(clean(desc))
      })
    //          console.log(JSON.stringify(desc, null, 2))})
  }
}
</script>
<style scoped>
</style>
